<template>
  <div class="ui-map-tabs">
    <div
      v-for="tabItem in tabs"
      :key="tabItem.value"
      class="ui-map-tab"
         :class="{'ui-map-tab_active': tabActive === tabItem.value}"
         :id="`tab-${tabItem.value}`"
         @click="$emit('changeTab', tabItem.value)"
    >
      {{ tabItem.label }}
    </div>
  </div>

</template>

<script>
export default {
  name: "mapTabs",
  props: {
    tabActive: {
      type: String,
      default: 'receptionLap',
    }
  },
  data: () => ({
    receptionQuery: true,
    tabs: [
      {
        label: 'Прием посылок от отправителя',
        value: 'receptionLap'
      },
      {
        label: 'Получение посылок получателем',
        value: 'deliveryLap'
      }
    ],
  }),

}
</script>


<style scoped lang="scss">
.ui-map-tabs {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #dedede;
}
.ui-map-tab {
  position: relative;
  margin: 0 33px;
  padding-bottom: 20px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
  color: #323232;
  cursor: pointer;

  @media (max-width: 767px) {
    margin: 0 5px;
    font-size: .9em;
    line-height: 1.2;
  }

  &_active {
    color: #ed1651;

    &::after {
      position: absolute;
      display: block;
      content: "";

      bottom: 0;
      width: 100%;
      height: 4px;
      background: #ed1651;
      border-radius: 2px;
    }
  }
}

</style>
